module.exports = require('./../dist/svg-components/social-regular/X');